export const errorMessages = (
  errorType: 'wrongToken' | 'emptyToken' | 'errorInValidation',
  message?: string,
): string => {
  const messages = {
    wrongToken: `Código incorreto`,
    emptyToken: `Digite o código`,
    errorInValidation: `Erro ao validar token: ${message}`,
  }
  return messages[errorType]
}
